<!--轮播图-->
<template>
  <div>
    <el-row>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <template>
          <el-carousel :interval="4000" type="card" height="300px">
            <el-carousel-item v-for="item in images" :key="item.imgName">
              <div style="width: 100%;height: 100%;display: flex;justify-content: space-around;">
                  <img :src="item.imgUrl" @click="fei(item.imgUrl)">
              </div>
            </el-carousel-item>
          </el-carousel>
        </template>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "AutoCut",
  data(){
    return{
      images: []
    }
  },
  methods:{
    fei(imgUrl){
      window.location.href = imgUrl;
    }
  },
  mounted(){
    axios.get('http://121.40.117.227:9091/uploadAuto').then(
        response => {
          console.log(response.data.data);
          this.images = response.data.data;
        },
        error => {
          console.log('请求失败！',error.message)
        }
    )
  }
}
</script>

<style scoped>

</style>
